<template>
  <contact-page-content :title="title">
    <template #subtitle>
      <div class="flex items-start gap-6">
        <app-image
          v-if="post?.og_image"
          alt=""
          class="aspect-square !w-16 rounded-lg object-cover sm:!w-20"
          :src="post.og_image"
          :width="100"
        />
        <div v-if="resource">
          <blog-post-resource-type-chip
            class="mb-2"
            size="small"
            :type="resource.type"
          />
          <p class="text-xl font-bold md:text-2xl">
            {{ resource.title }}
          </p>
        </div>
      </div>
    </template>

    <contact-page-content-feature-list
      class="hidden lg:block"
      :list="features"
    />
  </contact-page-content>
</template>

<script setup lang="ts">
import type { I18nMessage } from "@pollen/core/model/i18n.model";

import ContactPageContent from "~/pages/contact/_includes/components/content/contact-page-content.vue";
import ContactPageContentFeatureList from "~/pages/contact/_includes/components/content/contact-page-content-feature-list.vue";
import type { ContactFlowMetadata } from "~~/model/analytics.model";

const properties = defineProps<{
  metadata: ContactFlowMetadata;
}>();

const { data } = useLazyFetch(
  `/api/blog/posts/${properties.metadata.origin_page_id}/resources`,
  {
    default: () => [],
  },
);

const { data: post } = useLazyFetch(
  `/api/blog/posts/${properties.metadata.origin_page_id}`,
);

const resource = computed(() => data.value[0]);

const title = computed(() =>
  resource.value?.allow_download
    ? "Télécharger le contenu"
    : "Obtenir le contenu",
);

const features: { label: I18nMessage; icon: string }[] = [
  {
    label: "Des expériences partagées par le trainer",
    icon: "ph:users-four",
  },
  {
    label: "Du contenu actionnable",
    icon: "ph:cursor-click",
  },
  {
    label: "Des méthodes et conseils théoriques",
    icon: "ph:atom",
  },
];
</script>
